import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, Paper } from "@mui/material";
import { Link } from "react-router-dom"; // Import from react-router-dom

import removeStudentFromClass from "./removeStudentFromClass";
import * as CONSTANTS from "./../../../StringConstants.js"

// Define day order for sorting
const dayOrder = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"];

// Helper function to convert time string to comparable format
const convertTimeToNumber = (time) => {
  const [hours, minutes] = time.split(":").map(Number);
  return hours * 60 + minutes; // Convert time to total minutes for sorting
};

const IndividualStudentProfileClassesTable = ({ tlhStudentData }) => {

  // Convert object with numerical indices to an array
  const classesArray = tlhStudentData.classes ? Object.values(tlhStudentData.classes) : [];

  // Sort classes by day first, then by time
  const sortedClasses = classesArray.sort((a, b) => {
    const dayDiff = dayOrder.indexOf(a.classDay) - dayOrder.indexOf(b.classDay);
    if (dayDiff !== 0) return dayDiff; // Sort by day first
    return convertTimeToNumber(a.startTime) - convertTimeToNumber(b.startTime); // Then by time
  });

  const handleRemoveClick = async (classId) => {
    console.log(classId)
    console.log(tlhStudentData.tlhStudentId)
    try {
      await removeStudentFromClass(classId, tlhStudentData.tlhStudentId);
      // alert("Student removed successfully!");
      // Optionally, refresh state or trigger a re-fetch here
    } catch (error) {
      alert("Failed to remove student. Please try again.");
    }
  };

  return (
    <TableContainer component={Paper} sx={{ mt: 3, boxShadow: 3 }}>
      <Table>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#1976d2" }}>
            <TableCell sx={{ color: "white", fontWeight: "bold" }}>Class Name</TableCell>
            <TableCell sx={{ color: "white", fontWeight: "bold" }}>Start Time</TableCell>
            <TableCell sx={{ color: "white", fontWeight: "bold" }}>Class Day</TableCell>
            <TableCell sx={{ color: "white", fontWeight: "bold" }}>Class Type</TableCell>
            <TableCell sx={{ color: "white", fontWeight: "bold" }}>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedClasses.length > 0 ? (
            sortedClasses.map((classItem, index) => {
              // Insert a gap if this class is on a different day than the previous class
              const previousClass = sortedClasses[index - 1];
              const showGap = previousClass && previousClass.classDay !== classItem.classDay;

              return (
                <React.Fragment key={classItem.classId}>
                  {showGap && (
                    <TableRow>
                      <TableCell colSpan={5} sx={{ backgroundColor: "#f0f0f0", height: "15px" }}></TableCell>
                    </TableRow>
                  )}
                  <TableRow>
                    <TableCell>
                      <Link
                        to={CONSTANTS.ViewTLHClass + "/" + classItem.classId}
                        style={{ textDecoration: "none", color: "#1976d2", fontWeight: "bold" }}
                        >
                        {classItem.className}
                      </Link>
                    </TableCell>
                    <TableCell>{classItem.startTime}</TableCell>
                    <TableCell>{classItem.classDay}</TableCell>
                    <TableCell>{classItem.classType.replace("_", " ")}</TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        color="error"
                        size="small"
                        onClick={() => handleRemoveClick(classItem.classId)}
                      >
                        Remove
                      </Button>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              );
            })
          ) : (
            <TableRow>
              <TableCell colSpan={5} align="center">
                No classes found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default IndividualStudentProfileClassesTable;
